import { Avatar, Box, Divider, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useList } from '@refinedev/core';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const UserSelectTenant = ({ accounts, setIsSelectedTenant }) => {
  const router = useRouter();
  const { data } = useList({ resource: 'Tenants' });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [currentTenant, setCurrentTenant] = useState('');
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectTenant = () => {
    router.replace('/');
    setIsSelectedTenant(false);
  };

  useEffect(() => {
    const tenantId = localStorage.getItem('TENANT_ID');
    if (tenantId) {
      const tenant = data?.data.find((e) => e.id == tenantId);
      setCurrentTenant(tenant?.name ?? '');
    }
  }, [data]);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Profile">
          <IconButton
            className="profileIcon"
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar className="!bg-primary" sx={{ width: 40, height: 40 }}>
              {accounts[0]?.idTokenClaims?.given_name?.split('')[0].toUpperCase() as string}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>{currentTenant}</MenuItem>
        <div>
          <Divider />
          <MenuItem onClick={() => router.push('/feedback')}>
            <p className="text-primary">Feedback</p>
          </MenuItem>
          <MenuItem onClick={() => router.push('/support')}>
            <p className="text-primary">Support</p>
          </MenuItem>
        </div>

        {data?.data.length && data.data.length > 1 && (
          <div>
            <Divider />
            <MenuItem onClick={handleSelectTenant}>
              <p className="text-primary">Select another tenant</p>
            </MenuItem>
          </div>
        )}
      </Menu>
    </>
  );
};
